/* eslint-disable func-names, max-len */
import $ from 'jquery';
import delay from 'lodash/delay';
import MobileChecker from './init-check-device';

const $table = $('.js-responsive-table');
const $responsiveTable = $('.js-table-responsive');

$(window).on('resize', scrollTable);

function scrollTable() {
  delay(() => {
    $responsiveTable.each((index) => {
      if (MobileChecker.instance.isMobile() || MobileChecker.instance.isTablet()) {
        const $fixedColumn = $table.eq(index).clone().insertBefore($table.eq(index)).addClass('fixed-column');
        const tableWidth = $table.innerWidth();
        const contentWidth = $('.js-main-content').innerWidth();

        if (tableWidth > (contentWidth - 50)) {
          $responsiveTable.eq(index).addClass('make-scrollable');
        } else {
          $responsiveTable.eq(index).removeClass('make-scrollable');
        }

        $fixedColumn.find('th:not(:first-child),td:not(:first-child)').remove();
        $fixedColumn.find('tr').each(function (i) {
          $(this).height(Math.floor($table.eq(index).find(`tr:eq(${i})`).height()));
        });

        $fixedColumn.css({ width: 108 });
      }

      if (MobileChecker.instance.isDesktop()) {
        $responsiveTable.eq(index).removeClass('make-scrollable');
      }
    });
  }, 200);
}

$(document).ready(() => {
  if ($table.length) {
    scrollTable();
  }
});



// WEBPACK FOOTER //
// ./js/components/init-responsive-table.js